import React from 'react';
import i18next from 'i18next';
import Api from '../../api';
import apiForm from './apiForm';
import ProviderSelect from '../ProviderSelect/ProviderSelect';
import PendingButton from '../Button/PendingButton';
import SumInput from '../SumInput/SumInput';
import InputText from '../InputText/InputText';
import FormErrors from './FormErrors';
import makeCancelable from '../../api/cancelable';

const WITHDRAW_MIN_SUM = app.config.withdraw.min;
const WITHDRAW_MAX_SUM = app.config.withdraw.max;

class WithdrawForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  onSubmit = (e) => {
    const { promise, cancel } = makeCancelable(
      Api.withdraw(this.props.serializeForm(e.currentTarget))
    );
    this.requests.push(cancel);

    e.preventDefault();
    this.props.beforeSubmit();
    promise.then((response) => {
      this.props.afterSubmit(response);
    });
  };

  cartPlaceholder = (service) => {
    if (
      ['sberbank', 'alfa', 'visa_mastercard_ru', 'visa_mastercard_ua'].includes(
        service
      )
    )
      return i18next.t('withdraw.card_number');
    if (['qiwi'].includes(service)) return i18next.t('withdraw.phone_number');
    if (['fk_ru', 'yandex_money', 'webmoney_wmz'].includes(service))
      return i18next.t('withdraw.wallet_number');
  };

  render() {
    const {
      onInputChange,
      formState: { pending, errors, invalid, submitted, values },
    } = this.props;
    const blockSubmit =
      !values.service ||
      values.sum < WITHDRAW_MIN_SUM ||
      values.sum > WITHDRAW_MAX_SUM;

    return (
      <div className="form withdraw-form">
        <form onSubmit={this.onSubmit}>
          {(!submitted || errors.length !== 0) && (
            <React.Fragment>
              <span className="form__title form__title--center form__title--secondary">
                {i18next.t('withdraw.title')}
              </span>

              <SumInput
                sum={+values.sum}
                onChange={onInputChange.bind(this, 'sum')}
                min={WITHDRAW_MIN_SUM}
                max={WITHDRAW_MAX_SUM}
              />

              <ProviderSelect
                onSelect={onInputChange.bind(this, 'service')}
                activeProvider={values.service}
              />

              <InputText
                name="cart"
                placeholder={this.cartPlaceholder(values.service)}
                autoComplete="off"
                className={
                  'form__input' + (invalid.includes('cart') ? ' invalid' : '')
                }
              />

              <InputText
                name="password"
                placeholder={i18next.t('withdraw.password')}
                type="password"
                autoComplete="new-password"
                className={
                  'form__input' +
                  (invalid.includes('password') ? ' invalid' : '')
                }
              />

              <FormErrors errors={errors} />
            </React.Fragment>
          )}

          {submitted && errors.length === 0 && (
            <React.Fragment>
              <span className="form__title form__title--center">
                {i18next.t('withdraw.success')}
              </span>
              <p
                className="withdraw-form__success-text"
                dangerouslySetInnerHTML={{
                  __html: i18next.t('withdraw.success_text'),
                }}
              />
            </React.Fragment>
          )}

          <PendingButton
            tagName="button"
            className="form__submit withdraw-form__submit"
            disabled={blockSubmit}
            pending={pending}
            done={submitted && errors.length === 0}
          >
            {i18next.t('withdraw.action')}
          </PendingButton>

          <p
            className="withdraw-form__note"
            dangerouslySetInnerHTML={{
              __html: i18next.t('withdraw.success_text'),
            }}
          />
        </form>
      </div>
    );
  }
}

export default apiForm(WithdrawForm, {
  values: {
    sum: 0,
    service: 'sberbank',
  },
});



// WEBPACK FOOTER //
// ./app/components/Form/WithdrawForm.jsx